import { render, staticRenderFns } from "./collectionservicer.vue?vue&type=template&id=3d07c9b8&"
import script from "./collectionservicer.vue?vue&type=script&lang=js&"
export * from "./collectionservicer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports